import { tweened } from 'svelte/motion';
import { quintInOut } from 'svelte/easing';

let
	delay = 400,
	duration = 888,
	easing = quintInOut;

//positionX
export const positionX = tweened(0, {
	delay: delay,
	duration: duration,
	easing: easing
	}
);

//positionY
export const positionY = tweened(0, {
	delay: delay,
	duration: duration,
	easing: easing
	}
);

//dimensionX
export const dimensionX = tweened(1024, {
	delay: delay,
	duration: duration,
	easing: easing
	}
);

//dimensionY
export const dimensionY = tweened(1024, {
	delay: delay,
	duration: duration,
	easing: easing
	}
);
